import styled from 'styled-components'
import { Colors } from "./colors";

export const TitleStyle = styled.text`
    color: ${Colors.DarkGray};
    font-size: 36px;
    font-family: "inter";
`

export const SubtitleStyle = styled.text`
    color: ${Colors.LightGray};
    font-size: 24px;
    font-family: "inter";
`